module.exports = "/_next/static/images/harajuku_famous_lunch-4c493b5038f694c66fb59c8d7188f2e9.jpg";